import { action, observable, makeObservable } from 'mobx';
import {
  contentLoaders,
  ContentLookup,
  SuccessResponse,
  X1Language,
  X2AgeCategory,
  X3Level,
  X4Unit,
  X4UnitUpdateModel
} from '../../../../domain';
import {
  Control,
  HttpPromiseState,
  newValueForSelection,
  SaveStateHolder,
  validators
} from '../../../../lib/helpers';

export class MoveUnitStore implements SaveStateHolder {
  language: Control<X1Language | null>;
  ageCategory: Control<X2AgeCategory | null>;
  level: Control<X3Level | null>;

  readonly languageOptions: readonly X1Language[];
  @observable.ref
  ageCategoryOptions: readonly X2AgeCategory[];
  @observable.ref
  levelOptions: readonly X3Level[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly unit: X4Unit,
              readonly lookup: ContentLookup) {
    makeObservable(this);
    this.language = new Control<X1Language | null>(
      'Language',
      unit.Level!.AgeCategory!.Language,
      validators.required
    );

    this.language.addValueChangeListener((language) => {
      this.ageCategoryOptions = [];
      if (language !== null)
        this.ageCategoryOptions = language.AgeCategories!;
      const newValue = newValueForSelection(this.ageCategoryOptions, this.ageCategory.value);
      this.ageCategory.setValue(newValue);
    });

    this.ageCategory = new Control<X2AgeCategory | null>(
      'AgeCategory',
      unit.Level!.AgeCategory,
      validators.required
    );

    this.ageCategory.addValueChangeListener((ageCategory) => {
      this.levelOptions = [];
      if (ageCategory !== null)
        this.levelOptions = ageCategory.Levels!;
      const newValue = newValueForSelection(this.levelOptions, this.level.value);
      this.level.setValue(newValue);
    });

    this.level = new Control<X3Level | null>(
      'Level',
      unit.Level,
      validators.required
    );

    this.languageOptions = lookup.Languages;
    this.ageCategoryOptions = unit.Level!.AgeCategory!.Language!.AgeCategories!;
    this.levelOptions = unit.Level!.AgeCategory!.Levels!;

    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.language.markTouched();
    this.ageCategory.markTouched();
    this.level.markTouched();
    if (this.level.invalid)
      return;

    const model: X4UnitUpdateModel = {
      LevelId: this.level.value!.Id,
      Name: this.unit.Name
    };
    this.save = contentLoaders.x4unit.update(this.unit.Id, model);
  }
}
